export default "__VITE_ASSET__DMk3QoG9__"